import { IOpData, ICopyable } from '../util/interfaces'
import { Enums } from '../common/enums'
import { OpDataType } from './op-data-type'

export class OpConfigurationProfileData implements IOpData, ICopyable<OpConfigurationProfileData> {

    //#region Properties

    public idConfigurationProfileData: number
    public idConfigurationProfile: number
    public idDeviceType: number
    public idDeviceTypeProfileStep: number
    public idDataType: number
    public index: number
    public value: any

    //#endregion


    //#region Navigation properties

    public dataType: OpDataType

    //#endregion


    //#region Custom Properties

    public opState: Enums.OpChangeState

    //#endregion


    //#region Ctor
    constructor(opObj: any) {
        if (opObj instanceof OpConfigurationProfileData) {
            this.copy(<OpConfigurationProfileData>opObj, true, true, true, true)
        } else {
            this.fromJSON(opObj)
        }
    }

    //#endregion

    //#region ICopyable

    public clone(includeNavigationProperties: boolean, includeCustomProperties: boolean = false, includeDataList: boolean = false, includeDynamicValues: boolean = false): OpConfigurationProfileData {
        const configurationProfileData: OpConfigurationProfileData = new OpConfigurationProfileData(null)

        configurationProfileData.copy(this, includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues)

        return configurationProfileData
    }

    public copy(source: OpConfigurationProfileData, includeNavigationProperties: boolean, includeCustomProperties: boolean, includeDataList: boolean, includeDynamicValues: boolean): void {

        if (source == null) {
            return null
        }
        if (includeNavigationProperties) {
            this.dataType = source.dataType != null ? source.dataType.clone(includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues) : null
        }

        if (includeCustomProperties) {
            this.opState = source.opState
        }

        if (includeDataList) {
            // No Data List
        }

        if (includeDynamicValues) {
            // No Dynamic Values
        }

        this.idConfigurationProfileData = source.idConfigurationProfileData
        this.idConfigurationProfile = source.idConfigurationProfile
        this.idDeviceType = source.idDeviceType
        this.idDeviceTypeProfileStep = source.idDeviceTypeProfileStep
        this.idDataType = source.idDataType
        this.indexNBR = source.indexNBR
        this.value = source.value
        this.idData = source.idData
    }

    // #endregion


    //#region IOpData Implementation

    public get indexNBR() { return this.index }
    public set indexNBR(indexNBR: number) { this.index = indexNBR }

    public get idData() { return this.idConfigurationProfileData }
    public set idData(idData: number) { this.idConfigurationProfileData = idData }

    public toJSON(compressed: boolean = false): any {
        return {
            ID_CONFIGURATION_PROFILE_DATA: this.idConfigurationProfileData,
            ID_CONFIGURATION_PROFILE: this.idConfigurationProfile,
            ID_DATA_TYPE: this.idDataType,
            ID_DEVICE_TYPE: this.idDeviceType,
            ID_DEVICE_TYPE_PROFILE_STEP: this.idDeviceTypeProfileStep,
            INDEX_NBR: this.indexNBR,
            OpState: this.opState,
            VALUE: this.value,
            _DataType: (this.dataType != null) ? this.dataType.toJSON() : null
        }
    }

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj != null) {
            this.idConfigurationProfileData = opObj.ID_CONFIGURATION_PROFILE_DATA
            this.idConfigurationProfile = opObj.ID_CONFIGURATION_PROFILE
            this.idDataType = opObj.ID_DATA_TYPE
            this.idDeviceType = opObj.ID_DEVICE_TYPE
            this.idDeviceTypeProfileStep = opObj.ID_DEVICE_TYPE_PROFILE_STEP
            this.indexNBR = opObj.INDEX_NBR
            this.opState = opObj.opState
            this.value = opObj.VALUE
            this.dataType = (opObj._DataType != null) ? new OpDataType(opObj._DataType) : null
        }
    }


    public static fromIOpData(data: IOpData): OpConfigurationProfileData {
        const newData: OpConfigurationProfileData = new OpConfigurationProfileData(null)

        newData.idConfigurationProfileData = data.idData
        newData.idDataType = data.idDataType
        newData.indexNBR = data.indexNBR
        newData.idDeviceType = data['idDeviceType']
        newData.value = data.value
        newData.opState = data.opState

        return newData
    }

    //#endregion
}